/**
 * Created by jacmai on 3/23/2017.
 */

define([
  "marionette",
  "messaging/messenger",
  "./apiRequestValidationView",
  "./apiRequestValidationModel",
], function (Marionette, Messenger, ApiRequestValidationView, ApiRequestValidationModel) {
  var ApiRequestValidationController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "apirequestvalidation";
    },
    show: function (apiRequestItem) {
      this.actionItem = apiRequestItem;
      this.testVariables = Messenger.reqres.request(
        "api:test:variables",
        apiRequestItem.getAllVariableIds(),
        Messenger.reqres.request("action:all:variables"),
      );
      //merge old test variable values with the new list for any variables that still exist
      if (this.actionItem.testVariables) {
        this.testVariables.set(this.actionItem.testVariables.models, { add: false, remove: false });
      }
      //store the test variables on the action item in order to keep track of them if we return to this screen
      this.actionItem.testVariables = this.testVariables;
      this.view = new ApiRequestValidationView.apiRequestValidationView({
        collection: this.testVariables,
      });
      this.showRegion(this.view);
    },
    getActionItem: function () {
      return this.actionItem;
    },
    isValid: function (callback, context) {
      //get the test variable values and trigger a test request using those variables
      if (this.view.collectTestValues()) {
        this.view.displaySpinner();
        var testRequest = this.actionItem.testRequest(this.testVariables);
        testRequest.onSynced(function () {
          if (testRequest.get("successful")) {
            callback.apply(context);
          } else {
            this.view.displayTestError();
          }
        }, this);
      }
    },
  });

  return ApiRequestValidationController;
});
